import Header from "@components/Header";
import { Arrow, Button, Container, Typography } from "@vaporfi/uikit";
import Image from "next/image";
import Link from "next/link";

const NotFound = () => {
	return (
		<>
			<Header
				breadcrumbs={[
					{
						currenciesLabel: "",
						page: "Not found",
						path: "/",
					},
				]}
			/>
			<Container className="p-[30px]">
				<Container
					stack="column"
					itemsCenter
					fullWidth
					bg="black"
					className="gap-4 p-[30px]"
				>
					<Typography
						className="font-manverse text-custom-linear-gradient"
						weight="normal"
						capital
						size="base"
					>
						ERROR: PAGE NOT FOUND
					</Typography>

					<Image src="/images/404.png" alt="Error" width={300} height={90} />

					<Typography size="sm">
						{
							"The page you’re looking for doesn’t exist, or the URL you used was incorrect."
						}
					</Typography>
					<Link href="/swap" passHref legacyBehavior>
						<Button color="blue" variant="filled" size="base">
							<Typography size="sm">{"Make a Swap"}</Typography>
							<Arrow />
						</Button>
					</Link>
				</Container>
			</Container>
		</>
	);
};

export default NotFound;
